import { render } from "./surveyTemplateEditor.vue?vue&type=template&id=9359f98e&scoped=true&ts=true"
import script from "./surveyTemplateEditor.vue?vue&type=script&lang=ts"
export * from "./surveyTemplateEditor.vue?vue&type=script&lang=ts"

import "./surveyTemplateEditor.vue?vue&type=style&index=0&id=9359f98e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9359f98e"]])

export default __exports__